import { FunctionalComponent, h } from '@stencil/core';

export const LoadingIndicator: FunctionalComponent = () => {
  const color1 = '#333333';
  const color2 = '#333333';
  const color3 = '#ffffff';
  const color4 = '#ffffff';
  const color5 = '#000000';
  const color6 = '#000000';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <g transform="translate(50 50)">
        <g>
          <animateTransform attributeName="transform" type="rotate" calcMode="discrete" values="0;90;180;270;360" keyTimes="0;0.25;0.5;0.75;1" dur="2.5s" repeatCount="indefinite"></animateTransform>
          <path d="M-40 0A40 40 0 1 0 40 0" fill={color1}>
            <animate attributeName="fill" calcMode="discrete" values={[color1,color3,color4,color4,color1].join(';')} keyTimes="0;0.24;0.49;0.74;0.99" dur="2.5s" repeatCount="indefinite"></animate>
          </path>
          <path d="M-40 0A40 40 0 0 1 40 0" fill={color3}>
            <animate attributeName="fill" calcMode="discrete" values={[color3,color4,color4,color1,color3].join(';')} keyTimes="0;0.25;0.5;0.75;1" dur="2.5s" repeatCount="indefinite"></animate>
          </path>
          <path d="M-39 0L39 0" stroke={color1} stroke-width="2">
            <animate attributeName="stroke" values={[color1,color1,color2,color3,color2,color5,color4,color5,color6,color4,color6,color1,color1].join(';')} keyTimes="0;0.124;0.125;0.25;0.374;0.375;0.5;0.624;0.625;0.75;0.874;0.875;1" dur="2.5s" repeatCount="indefinite"></animate>
          </path>
          <g>
            <path d="M-40 0A40 40 0 0 1 40 0Z" fill={color1}>
              <animate attributeName="fill" values={[color1,color1,color2,color3,color2,color5,color4,color5,color6,color4,color6,color1,color1].join(';')} keyTimes="0;0.124;0.125;0.25;0.374;0.375;0.5;0.624;0.625;0.75;0.874;0.875;1" dur="2.5s" repeatCount="indefinite"></animate>
              <animateTransform attributeName="transform" type="scale" values="1 1;1 0;1 -1;1 1" keyTimes="0;0.5;0.999;1" dur="0.625s" repeatCount="indefinite"></animateTransform>
            </path></g>
        </g>
      </g>
    </svg>
  );
}
